import ReactDOM from 'react-dom';
import React from "react";
import "./GuideVideoModal.css";

const GuideVideoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="guidevideomodal-overlay">
      <div className="guidevideomodal-content">
        <button className="guidevideo-close-button" onClick={onClose}>x</button>
        <video width="100%" controls autoPlay>
          <source src="/path/to/tutorial-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>,
    document.getElementById('root')
  );
};

export default GuideVideoModal;
